import ArticleLayout from "../components/ArticleLayout";

export default function HoodiesGuide() {
  return <ArticleLayout articleId={7} />;
}